import { requestApiSaga } from '@client/common/redux/api/sagas';
import {
  createRemoteRecordCleanUpSaga,
  REMOTE_RECORD_CLEAN_UP_DEBOUNCE,
} from '@client/common/redux/effects/createRemoteRecordCleanUpSaga';
import { reportError } from '@client/common/redux/errors/actions';
import { parseError } from '@client/common/utils/api/error';
import { ProductAccessories } from '@client/product/api/ProductAccessories';
import {
  fetchProductAccessories, fetchProductAccessoriesCleanUp,
  fetchProductAccessoriesFulfilled,
  fetchProductAccessoriesRejected, selectProductAccessoriesRecords,
} from '@client/product/redux/productAccessories/redux';
import { AxiosResponse } from 'axios';
import { all, AllEffect, call, CallEffect, debounce, ForkEffect, put, PutEffect, takeEvery } from 'redux-saga/effects';
import { ProfileType } from 'b2b-common/core/context/Context.types';

function* fetchProductAccessoriesSaga(
  action: ReturnType<typeof fetchProductAccessories>,
): Generator<CallEffect | PutEffect, void, AxiosResponse & ProfileType> {
  const { sku } = action.payload;

  try {
    const response = yield call(requestApiSaga, ProductAccessories.fetch(sku));
    const productAccessories = ProductAccessories.mapResponseToState(
      response,
    );
    yield put(fetchProductAccessoriesFulfilled({ sku, data: productAccessories }));
  } catch (error) {
    yield put(fetchProductAccessoriesRejected({ sku, error: parseError(error) }));
    yield put(reportError({ message: action.type, error, additionalData: action.payload }));
  }
}

export function* productAccessoriesSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeEvery(fetchProductAccessories.type, fetchProductAccessoriesSaga),
    debounce(
      REMOTE_RECORD_CLEAN_UP_DEBOUNCE,
      [fetchProductAccessoriesFulfilled.type, fetchProductAccessoriesRejected.type],
      createRemoteRecordCleanUpSaga(
        selectProductAccessoriesRecords,
        fetchProductAccessoriesCleanUp.type,
      ),
    ),
  ]);
}
